// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1IMrl","actions":"GroupTable_actions__Zp4I5","deleteModalFooter":"GroupTable_deleteModalFooter__2UBHW"};